import * as storageService from 'services/storage.service';
import userService from 'resources/user/user.service';

export const getUsersWithAvatars = async (userTypes = null) => {
  let users = await userService.getCompanyUsers(userTypes) || [];

  users = await Promise.all(
    users.map(async (user) => {
      if (!user.avatar_url) {
        return user;
      }

      const avatarUrl = await storageService.getAvatarUrl(user.avatar_url);

      return {
        ...user,
        avatar_id: user.avatar_url,
        avatar_url: avatarUrl,
      };
    })
  );

  return users;
};
